import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-ui-back-button",
  templateUrl: "./ui-back-button.component.html",
  styleUrls: ["./ui-back-button.component.scss"],
})
export class UiBackButtonComponent {
  @Input() previousPages: string[] = [];
  @Output() goToPreviousPage = new EventEmitter();

  /**
   * Emits an event requesting navigation back to the previous page.
   */
  public onBack(): void {
    this.goToPreviousPage.emit(true);
  }
}
